import { useTranslation } from '@eon/i18n';
import { cn } from '@eon/utils';
import { COMMAND_GROUPS, COMMANDS } from './commands';
import type { CommandId } from './types';

export function CommandSidebar({
  selected,
  onSelect,
  disabled,
}: {
  selected: CommandId;
  onSelect: (id: CommandId) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <nav className="space-y-4" aria-label={t('deviceControl.commandsNav')}>
      {COMMAND_GROUPS.map((group) => {
        const items = COMMANDS.filter((c) => c.group === group.id);
        if (items.length === 0) return null;
        return (
          <div key={group.id}>
            <p className="text-muted-foreground mb-1.5 px-2 text-[11px] font-semibold uppercase tracking-wider">
              {t(group.labelKey)}
            </p>
            <ul className="space-y-0.5">
              {items.map((cmd) => {
                const active = cmd.id === selected;
                return (
                  <li key={cmd.id}>
                    <button
                      type="button"
                      disabled={disabled}
                      onClick={() => onSelect(cmd.id)}
                      className={cn(
                        'flex w-full items-center gap-2 rounded-md px-2 py-2 text-left text-sm transition-colors',
                        active
                          ? 'bg-primary text-primary-foreground'
                          : 'hover:bg-muted text-foreground',
                        disabled && 'pointer-events-none opacity-50',
                      )}
                    >
                      <span
                        className={cn(
                          'flex h-7 w-7 shrink-0 items-center justify-center rounded-md',
                          active ? 'bg-primary-foreground/15' : 'bg-muted',
                        )}
                      >
                        {cmd.icon}
                      </span>
                      <span className="truncate font-medium">{t(cmd.labelKey)}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </nav>
  );
}
